module.exports = __webpack_public_path__ + "static/GloberSemiBold-7976402f69c06e3489243c458db23fcc.woff";